<template>
  <div class="newlist">
    <ul class="list1">
      <li v-for="(item, index) in cidList" @click="gopageinfo(item.id)">
        <div class="li_l">
          <div class="li_title">{{ item.title }}</div>
          <!-- <div class="li_tag"><span>音频</span>{{ item.synopsis }}</div> -->
          <div class="li_tag">{{ item.tag }}</div>
        </div>
        <div class="li_r">
          <img :src="item.image_input[0]" class="li_img " />
          <div>引流{{ item.visit ? item.visit : 0 }}次</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import toLogin from "@libs/login";
import { couponReceiveBatch } from "@api/user";
export default {
  name: "CouponWindow",
  props: {
    cidList: {
      type: Array,
      default: () => []
    }
  },
  computed: mapGetters(["isLogin"]),
  data: function() {
    return {
      value: true
    };
  },
  mounted: function() {},
  methods: {
    gopageinfo(e) {
      this.$router.push({ path: "/jiaodian/imgtextDetail?id=" + e });
    }
  }
};
</script>

<style></style>
